module.exports = __webpack_public_path__ + "img/five_econ.72a0b96e.png";